import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getAction, httpAction } from '@/api/manage';
export default {
  name: 'workFLow',
  props: {
    createBy: {
      type: String | Number,
      default: 0
    },
    //该条项目发起人
    flowSrc: {
      type: String,
      default: 'om_process_currency'
    },
    srcId: {
      type: String | Number,
      default: 0
    } //该条项目id

  },
  data: function data() {
    return {
      confirLoading: false,
      userInfo: this.$store.getters.userInfo,
      flowData: {
        workFlowItemList: []
      },
      currentStatusId: 0,
      //当前流程的id
      currentUserStatus: false,
      //当前用户是否可编辑状态
      flowIndex: 0
    };
  },
  mounted: function mounted() {
    this.getFlowData();
  },
  methods: {
    // 流程撤销-2、拒绝-3
    onToDelete: function onToDelete(type) {
      var _this = this;

      this.confirLoading = true;
      var flowData = JSON.parse(JSON.stringify(this.flowData));
      var currentNode = {};
      var suggest = '撤销';

      if (type == '-2') {
        suggest = '撤销';
        currentNode = _objectSpread({}, flowData.workFlowItemList[0]);
      } else {
        suggest = '拒绝';
        var currentNodeList = flowData.workFlowItemList.filter(function (item) {
          return item.statusId == _this.currentStatusId;
        }).filter(function (item1) {
          return item1.approvalUser[0].id == _this.userInfo.id;
        });
        currentNode = currentNodeList[currentNodeList.length - 1];
      }

      var postDatas = {
        id: flowData.id,
        srcId: flowData.srcId,
        userId: flowData.workFlowItemList[0].userId,
        statusId: type,
        workFlowItemList: [{
          id: currentNode.id,
          statusId: currentNode.statusId,
          suggest: currentNode.suggest || suggest
        }]
      };
      httpAction("/sys/work/flow/endApproval", postDatas, 'put').then(function (res) {
        if (res.success) {
          if (type == '-2') {
            _this.$message.success('已撤销!');
          } else {
            _this.$message.success('已拒绝!');
          }

          _this.$emit('close');
        } else {
          _this.$message.error(res.message);
        }
      }).finally(function () {
        _this.confirLoading = false;
      });
    },
    // 流程同意、驳回
    onToStart: function onToStart(agreeFlag) {
      var _this2 = this;

      var flowData = JSON.parse(JSON.stringify(this.flowData));
      var suggest = '同意';

      if (agreeFlag) {
        suggest = '同意';
      } else {
        suggest = '驳回';
      }

      var currentNodeList = flowData.workFlowItemList.filter(function (item) {
        return item.statusId == _this2.currentStatusId;
      }).filter(function (item1) {
        return item1.approvalUser[0].id == _this2.userInfo.id;
      });
      var currentNode = currentNodeList[currentNodeList.length - 1];
      var postDatas = {
        id: flowData.id,
        srcId: flowData.srcId,
        userId: flowData.workFlowItemList[0].userId,
        workFlowItemList: [{
          userId: currentNode.userId,
          statusId: currentNode.statusId,
          nextStatusId: currentNode.nextStatusId,
          id: currentNode.id,
          suggest: currentNode.suggest || suggest,
          agreeFlag: agreeFlag
        }]
      };
      this.confirLoading = true;
      httpAction("/sys/work/flow", postDatas, 'put').then(function (res) {
        if (res.success) {
          if (agreeFlag) {
            _this2.$message.success('已同意！');
          } else {
            _this2.$message.success('已驳回！');
          }

          _this2.$emit('close');
        } else {
          _this2.$message.error(res.message);
        }
      }).finally(function () {
        _this2.confirLoading = false;
      });
    },
    getFlowData: function getFlowData() {
      var _this3 = this;

      var srcId = this.srcId;
      getAction("/sys/work/flow/".concat(this.flowSrc, "/").concat(this.srcId), {}).then(function (res) {
        if (res.success) {
          _this3.flowData = {
            userId: _this3.userInfo.id,
            flowSrc: _this3.flowSrc,
            srcId: srcId,
            workFlowItemList: []
          };

          if (res.result) {
            var data = res.result;
            _this3.flowData = _objectSpread(_objectSpread({}, data), _this3.flowData);
            data.workFlowItemList.forEach(function (item, index) {
              if (data.statusId == '-2' || data.statusId == '-3') {
                _this3.flowIndex = data.workFlowItemList.length - 1;
              } else {
                if (item.statusId == data.statusId) {
                  _this3.flowIndex = index;
                }
              }
            });
            _this3.currentStatusId = data.statusId; // 处理当前用户是否有审批权限

            if (_this3.currentStatusId > 0) {
              var currentUserList = data.workFlowItemList.filter(function (item) {
                return item.statusId == _this3.currentStatusId;
              }).map(function (v) {
                return v.approvalUser[0].id;
              });

              if (currentUserList.includes(_this3.userInfo.id)) {
                _this3.currentUserStatus = true;
              } else {
                _this3.currentUserStatus = false;
              }
            } else {
              _this3.currentUserStatus = false;
            }

            _this3.flowData.id = data.id;
            _this3.flowData.workFlowItemList = data.workFlowItemList;
          }
        } else {
          _this3.$message.error(res.message);
        }
      });
    }
  }
};